module.exports = " <span class=coorditate-buttons> <button type=button class=\"fa fa-minus\" @click=\"$emit('remove')\" v-bind:title=\"'Удалить ' + title\" v-if=canRemove></button> <button type=button class=\"fa fa-plus\" @click=\"$emit('add')\" v-bind:title=\"'Добавить ' + title\" v-if=canAdd></button> </span> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/CoordinateListButtons.vue
// module id = 209
// module chunks = 0